module.exports = __webpack_public_path__ + "img/classical.e34278ff.png";